import { CHANGE_BILLING_CYCLE_ROUTE } from '../../../../components/pages/ChangeBillingCycle/changeBillingCycleRoute'
import { NOT_BILLING_ADMIN } from '@app/common/src/components/PlanPurchaseExperience/constants'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { sendNotification } from '@dtx-company/inter-app/src/utils/notifications'
import { useBuyPlanPageQuery } from '../routing/useBuyPlanPageQuery'
import { useEffect } from 'react'
import { useFlowRouter } from '@dtx-company/inter-app/src/hooks/useFlowRouter'
import { usePaymentMethodError } from '@app/common/src/components/PlanPurchaseExperience/usePaymentMethodError'
import { usePlanPurchaseProviderContext } from '@app/plans/src/purchase/usePlanPurchaseProviderContext/usePlanPurchaseProviderContext'

export function useBuyPlanPageRedirects(): void {
  const flowRouter = useFlowRouter()
  const { forExistingUser } = useBuyPlanPageQuery()
  const { loadingErrorType } = usePlanPurchaseProviderContext()
  const { getErrorMessage } = usePaymentMethodError()

  useEffect(() => {
    if (!loadingErrorType) return

    const redirectToAccount = (): void => {
      flowRouter.replace({
        pathname: Routes.ACCOUNT,
        query: {
          billing: '1'
        }
      })
    }

    const redirectToChangeBillingCycle = (): void => {
      flowRouter.replace(CHANGE_BILLING_CYCLE_ROUTE)
    }

    const redirectToAuthPage = (): void => {
      flowRouter.replace({
        pathname: forExistingUser ? Routes.SIGN_IN : Routes.SIGN_UP,
        query: {
          ...flowRouter.query,
          redirectTo: encodeURIComponent(flowRouter.asPath)
        }
      })
    }

    if (loadingErrorType === 'not-logged-in') {
      redirectToAuthPage()
    } else if (loadingErrorType === NOT_BILLING_ADMIN) {
      sendNotification({ message: getErrorMessage(new Error(loadingErrorType)) })
      redirectToAccount()
    } else if (loadingErrorType === 'downgrade-not-allowed') {
      sendNotification({
        message: `Please contact us to downgrade your organization's account.`
      })
      redirectToAccount()
    } else if (loadingErrorType === 'already-on-plan') {
      redirectToChangeBillingCycle()
    }
  }, [loadingErrorType, flowRouter, forExistingUser, getErrorMessage])
}
